import { render, staticRenderFns } from "./ProjectItemPlaceholder.vue?vue&type=template&id=42af4c7e&"
import script from "./ProjectItemPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports